import React from 'react';
import Field from 'components/Field.jsx';
import Label from 'components/Label.jsx';
import Dialog from 'components/Dialog.jsx';
import Button from 'components/Button.jsx';
import BoxBody from 'components/BoxBody.jsx';
import BoxFooter from 'components/BoxFooter.jsx';
import SchoolPicker from 'components/SchoolPicker.jsx';
import { OrganizationTypes } from 'constants/OrganizationConstants';

class SchoolPickerModal extends React.Component {
  static propTypes = {
    onSchoolSelect: React.PropTypes.func.isRequired,
    onNotTeacher: React.PropTypes.func.isRequired,
  };

  state = {
    schoolId: null,
  };

  onNotTeacher = () => {
    this.props.onRequestHide();
    this.props.onNotTeacher();
  };

  onSchoolSelect = () => {
    this.props.onRequestHide();
    this.props.onSchoolSelect(this.state.schoolId);
  };

  render() {
    return (
      <Dialog
        eventScreenName="SchoolPickerModal"
        {...this.props}
        className="SetupSchool"
        hideCloseButton={false}
        full
        title="Select your school"
        size="small">
        <BoxBody divided>
          <Field className="SetupGroup-field">
            <Label>My school</Label>
            <SchoolPicker
              schoolId={this.state.schoolId}
              organizationType={OrganizationTypes.SCHOOL}
              placeholder="Search for a school"
              onSelect={value => this.setState({ schoolId: value })}
              onClear={() => this.setState({ schoolId: null })}
              onNoSchool={this.handleDontWorkClick}
              autofocus
            />
          </Field>
          <Button disabled={!this.state.schoolId} onClick={this.onSchoolSelect}>
            Select
          </Button>
        </BoxBody>
        <BoxFooter className="SetupSchool-footer">
          <Button
            className="SetupSchool-dontWorkButton"
            level="text"
            size="small"
            onClick={this.onNotTeacher}
            eventElementName="SetupSchool-dontWorkButton">
            I don’t teach at a school
          </Button>
        </BoxFooter>
      </Dialog>
    );
  }
}

export default SchoolPickerModal;



// WEBPACK FOOTER //
// ./src/components/SchoolPickerModal.jsx